<template>
  <div>
    <h2>OUR SALE IS STARTING SOON</h2>

    <Countdown :end="endDate" class="countdown" />

    <Button
      tag="a"
      theme="primary-light"
      :href="multipassAccount.url"
      class="wishlist-button"
    >
      Go to account
    </Button>
  </div>
</template>

<script>
import Button from "@/components/ButtonV3.vue";
import Countdown from "@/components/landing/Countdown.vue";
import { mapState } from "vuex";

export default {
  name: "HoldingSuccess",
  components: {
    Countdown,
    Button,
  },
  props: {
    endDate: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState("auth", ["multipassAccount"]),
  },
};
</script>

<style lang="scss" scoped>
h2 {
  @include editorial-headline(24px);
  text-transform: uppercase;
  margin-bottom: 16px;
}

p {
  @include editorial-body(14px);
  margin-bottom: 28px;
}

.countdown {
  margin-bottom: 28px;
}

.wishlist-button {
  display: inline-block;
}

:deep(.button--outline) {
  border-color: $color-white;
  color: $color-white;
}
</style>
